<template>
  <div
    class="computer-drop"
    @dragover.prevent
    @drop.stop.prevent="onDrop">
    <Spinner
      v-show="isLoading"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"/>
    <div class="computer-zone">
      <span class="computer-badge">
        <icon name="fileUpload"/>
      </span>
      <p class="computer-title">You can drag and drop file(s) to upload</p>
      <span class="computer-or">or</span>
      <label
        class="computer-browse"
        for="vfile-upload">
        Browse file
      </label>
      <input
        id="vfile-upload"
        class="computer-input"
        type="file"
        accept=".mp4"
        multiple
        @change="videoUploaded">
      <span class="computer-hint">MP4</span>
      <div
        v-if="showExtensionError"
        class="upload-alert"
        role="alert">
        <icon name="alert-circle"/>
        <span>Please only upload .mp4 files</span>
      </div>
      <div
        v-if="uploadError"
        class="upload-alert"
        role="alert">
        <icon name="alert-circle"/>
        <span>File cannot be uploaded</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from 'vue-simple-spinner';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import EventBus from '../../EventBus';

export default {
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading:          false,
      showExtensionError: false,
      modalHidden:        true,
      uploadError:        false,
      totalFiles:         0,
      currentFile:        0,
    };
  },
  mounted() {
    this.modalHidden = false;
    EventBus.$on('abortVideoUpload', this.abortVideoFileUpload);
  },
  methods: {
    onDrop(event) {
      const files = event.dataTransfer && event.dataTransfer.files;
      if (!files || !files.length) return;
      this.videoUploaded({ target: { files } });
    },
    async videoUploaded(e) {
      const self              = this;
      this.isLoading          = true;
      this.showExtensionError = false;
      this.uploadError        = false;
      this.modalHidden        = false;
      const files             = Array.from(e.target.files);
      self.totalFiles         = files.length;
      if (files.length === 0) {
        this.isLoading = false;
        alert('No files selected!');
        return;
      }

      let hasValidFile = false;

      for (const file of files) {
        const extension = file.name.split('.').pop().toLowerCase();
        if (extension !== 'mp4') {
          this.showExtensionError = true;
          continue;
        }
        if ((file.size / 1024 / 1024) > 50) {
          this.isLoading = false;
          alert(`Video file size cannot exceed 50MB: ${file.name}`);
          continue;
        }
        hasValidFile = true;
        await this.postVideo({ target: { files: [file] } });
      }
      if (!hasValidFile) this.isLoading = false;
    },
    enableVideoMode() {
      const isVideoModeOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];
      if (!isVideoModeOn) {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      }
    },
    async postVideo(event) {
      const self               = this;
      const file               = event.target.files[0];
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      const videoData          = {
        Id:           '',
        Name:         file.name,
        videoDetails: {
          duration: null,
          height:   null,
          width:    null,
          mimeType: '',
        },
        AlternativeVideoUrlsResVersion: [],
      };

      const reqFormData = new FormData();
      reqFormData.append('file', file);
      const headers   = {
        'Content-Type': 'text/plain',
      };
      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/WebServices/UploadVideos.ashx?userId=${userId}`, reqFormData, { headers })
        .then(async (response) => {
          if (response.data && !this.modalHidden) {
            videoData.videoDetails.VideoSourceUrl       = response.data.VirtualPath;
            videoData.videoDetails.videoHighRes         = response.data.HighResUrl;
            videoData.videoDetails.audio                = response.data.AudioUrl;
            videoData.videoDetails.duration             = response.data.Duration;
            videoData.videoDetails.width                = response.data.Width;
            videoData.videoDetails.height               = response.data.Height;
            videoData.videoDetails.ThumbnailVirtualPath = response.data.ThumbnailVirtualPath;

            videoData.AlternativeVideoUrlsResVersion.push(response.data);
            setTimeout(() => {
              // self.isLoading = false;
              EventBus.$emit(ApplicationEventTypes.Video.ADD_NEW_VIDEO_ON_CANVAS, videoData);
              EventBus.$emit('SetPageVideoLength', videoData.videoDetails.duration);

              self.currentFile += 1;
              if (self.currentFile === self.totalFiles) {
                self.$store.commit('setDisplayAddVideoModal', false);
                self.$store.commit('setIsVideoModel', false);
                this.enableVideoMode();
              }
            }, 10);
          } else {
            alert(response.data.message);
            self.isLoading = false;
          }
        })
        .catch((e) => {
          console.log(error);
          self.isLoading = false;
          alert('File can not be uploaded');
          EventBus.$emit('AddNewVideoOnCanvas', videoData);
        });
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
    abortVideoFileUpload() {
      this.modalHidden = true;
    },
    async waitUntilVideoStateReady(video) {
      try {
        return await new Promise((resolve) => {
          const interval = setInterval(() => {
            if (video.readyState > 0) {
              resolve(video.duration);
              clearInterval(interval);
            }
          }, 200);
        });
      } catch (error) {
        console.log(error);
        return error;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.computer-drop {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
}

.computer-zone {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  padding: 40px;
  border: 1.5px dashed #D5D9E0;
  border-radius: 14px;
  background: #FBFBFC;
  text-align: center;
}

.computer-badge {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #EAF2FE;
  color: #0B57C2;
}

.computer-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: #14161B;
}

.computer-or,
.computer-hint {
  font-size: 13px;
  line-height: 1.3;
  color: #5E6573;
}

.computer-hint {
  font-size: 12.5px;
}

.upload-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 420px;
  margin-top: 4px;
  padding: 8px 12px;
  border-radius: 9px;
  background: #FEF3F2;
  box-shadow: inset 0 0 0 1px #FBC9C4;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #912018;
  text-align: left;
}

.upload-alert ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
  color: inherit;
}

.upload-alert ::v-deep .icon svg {
  display: block;
  width: 15px;
  height: 15px;
}

.computer-browse {
  height: 38px;
  min-height: 38px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  background: #fff;
  color: #14161B;
  box-shadow: inset 0 0 0 1px #D5D9E0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.computer-browse:hover {
  background: #F3F4F6;
}

.computer-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.computer-badge ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.computer-badge ::v-deep .icon svg {
  display: block;
  width: 26px;
  height: 26px;
}

.inner-Loader {
  height: 100%;
  width: 100%;
  background: rgb(255, 255, 255);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
}
</style>
